(function(module) {
try {
  module = angular.module('betosyswebapp');
} catch (e) {
  module = angular.module('betosyswebapp', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('components/home/home.tpl.html',
    '');
}]);
})();



// WEBPACK FOOTER //
// ./.tmp/components/home/home.tpl.js